import React, { useState } from 'react';
import Imgix, { buildURL } from 'react-imgix';
import url from 'url';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e3) {
      didErr = true;
      err = _e3;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
/**
 * These constants are the prefixes for Imgix.
 */


var WWW_IMGIX_BUCKET_PREFIX = 'modsy'; // images coming from BE APIs, product images and renders

var WC_IMGIX_BUCKET_PREFIX = 'modsy-wc'; // images coming locally from this repo

/**
 * Main Configuration.
 * For SSR apps, we will need to manually set the runtime config.
 * For non SSR apps, the config is specified at build time via environment variables.
 *
 * In order to use Imgix for local dev it is required to set both the runtimeUseImgix
 * and runtimeAssetPrefix variables.
 *
 * When full image URL is passed from BE www API, we can use Imgix for local
 * dev right away because the image already exists and has been uploaded to S3.
 *
 * When we are working with a local image asset, we can use Imgix for local dev only AFTER
 * that image asset has been deployed up to S3 as part of our deployment process because
 * the image must exist in S3 before it can be used by Imgix. One way to do this would be
 * to create an image asset only PR and get that checked in and deployed to master.
 * Otherwise, local dev can bypass Imgix and just use the local image by setting
 * runtimeUseImgix to false.
 */

var runtimeBuildEnv = process.env.NODE_ENV || '';
var runtimeAppEnv = process.env.REACT_APP_ENV || process.env.REACT_APP_IMGIX_ENV || '';
var runtimeUseImgix = process.env.REACT_APP_USE_IMGIX || false; // only used for local dev

var runtimeAssetPrefix = process.env.REACT_APP_IMGIX_ASSET_PREFIX || ''; // only used for local dev

var runtimeDisableImgix = false; // only used for local dev

function setRuntimeConfig(_ref) {
  var appEnv = _ref.appEnv,
      buildEnv = _ref.buildEnv,
      useImgix = _ref.useImgix,
      assetPrefix = _ref.assetPrefix,
      disableImgix = _ref.disableImgix;
  runtimeBuildEnv = buildEnv || runtimeBuildEnv;
  runtimeAppEnv = appEnv || runtimeAppEnv;
  runtimeUseImgix = useImgix || runtimeUseImgix;
  runtimeAssetPrefix = assetPrefix || runtimeAssetPrefix;
  runtimeDisableImgix = disableImgix || runtimeDisableImgix;
} // Determine the Imgix hostname based on REACT_APP_ENV variable.
// For local dev, we will omit the hostname which will just
// default to using the full size master image. This can be overrided
// for local dev though by passing in useImgix=true.


var computeImgixHostname = function computeImgixHostname(bucketName) {
  // Fetch Imgix domain prefix if s3 bucketName provided else use default wc prefix
  var imgixDomainPrefix = bucketName ? fetchImgixDomainPrefix(bucketName) : WC_IMGIX_BUCKET_PREFIX; // Always default to local images for tests or when Imgix is explicitly disabled.

  if (runtimeBuildEnv === 'test' || runtimeDisableImgix) {
    return '';
  } // For local dev builds ONLY, we allow an asset prefix.
  // For regular production builds, webpack will insert the asset prefix for us.
  // let assetPrefix = '';
  // if (runtimeBuildEnv !== 'production' && imgixDomainPrefix === WC_IMGIX_BUCKET_PREFIX) {
  //   assetPrefix = runtimeAssetPrefix; // this only applies to local images
  // }
  // Always use Imgix for production builds.
  // For local builds, optionally override to Imgix.


  if (runtimeBuildEnv === 'production' || runtimeUseImgix) {
    // MOVED TO INTERNAL SERVICE AS PART OF MODSY WIND DOWN WORK
    // switch (runtimeAppEnv) {
    //   case 'dev':
    //     return `https://${imgixDomainPrefix}-dev.imgix.net${assetPrefix}`;
    //   case 'staging':
    //     return `https://${imgixDomainPrefix}-staging.imgix.net${assetPrefix}`;
    //   case 'prod':
    //     return `https://${imgixDomainPrefix}-prod.imgix.net${assetPrefix}`;
    //   case 'local':
    //     return '';
    //   default:
    //     console.log(`Error: unrecognized runtimeAppEnv value ${runtimeAppEnv}`);
    //     return '';
    // }
    if (imgixDomainPrefix === WC_IMGIX_BUCKET_PREFIX) {
      // The modsy image service does not currently support these S3 buckets
      // so we will need to send down full, uncompressed images.
      return '';
    }

    switch (runtimeAppEnv) {
      case 'dev':
        return "https://cache-dev.modsy.com/imgresize";

      case 'staging':
        return "https://cache-staging.modsy.com/imgresize";

      case 'prod':
        return "https://cache.modsy.com/imgresize";

      case 'local':
        return '';

      default:
        console.log("Error: unrecognized runtimeAppEnv value ".concat(runtimeAppEnv));
        return '';
    }
  } // Default to local images for local builds.


  return '';
};

var fetchImgixDomainPrefix = function fetchImgixDomainPrefix(bucketName) {
  switch (bucketName) {
    case 'modsy':
    case 'modsy-dev':
    case 'modsy-staging':
      return WWW_IMGIX_BUCKET_PREFIX;

    case 'modsy-warehouse-client-us-west':
    case 'modsy-warehouse-client-us-west-dev':
    case 'modsy-warehouse-client-us-west-staging':
      return WC_IMGIX_BUCKET_PREFIX;

    default:
      return '';
  }
};
/**
 * Default Imgix configuration parameters.
 */


var defaultImgixParams = function defaultImgixParams(disableAutoSrcSet) {
  return {
    // https://docs.imgix.com/apis/url/auto/auto
    // We may need to revisit these settings.
    auto: "compress,format".concat(disableAutoSrcSet ? '' : ',enhance'),
    // Resizes the image to fit within the width and height boundaries
    // without cropping or distorting the image. The resulting image
    // will match one of the constraining dimensions, while the other
    // dimension is altered to maintain the same aspect ratio of the
    // input image.
    fit: 'clip'
  };
};
/**
 * Given an image src, returns a compressed URL.
 * This is useful for CSS background-image url or quick
 * compression at a single resolution.
 */


var buildCompressedUrl = function buildCompressedUrl(src, params, bucketName) {
  // If the incoming src is a data URI, then
  // just return it as its already compressed.
  if (src.startsWith('data:')) {
    return src;
  } // Extract src path.
  // If the src path begins with a recognized
  // S3 bucket name then strip it out.


  var srcPath = url.parse(src).pathname;
  srcPath = srcPath.replace(/^\/modsy\//, '/').replace(/^\/modsy-staging\//, '/').replace(/^\/modsy-dev\//, '/'); // Determine the Imgix hostname

  var imgixHostName = computeImgixHostname(bucketName); // Determine final Imgix src url or default to src

  var imgixSrc = imgixHostName ? "".concat(imgixHostName).concat(srcPath) : src;
  var imgixUrl = buildURL(imgixSrc, params || defaultImgixParams(), {
    disableLibraryParam: true
  });
  return imgixUrl;
};

var _excluded = ["bucketName", "crop", "fit", "src", "sizes", "height", "width", "masterImageWidth", "className", "disableAutoEnhance", "disableAutoSrcSet", "onLoad", "useModsyImgDefaults", "handleRef"];
/**
 * Leverages Imgix to request an image with automatic/optimized compression.
 * When used with the 'sizes' attribute also compresses/optimizes for resolution and dpi.
 *
 * @param {string} src - The master image source path. Typically directly from the react import.
 * @param {string} sizes - The HTML sizes attribute (see: https://ericportis.com/posts/2014/srcset-sizes/)
 * @param {Number} width - The image width in CSS pixels. Prefer if known.
 * @param {Number} height - The image height in CSS pixels. Prefer if known.
 * @param {Number} masterImageWidth - [Optional] The width of the master image if fixed. Optimizes srcSet array.
 * @param {boolean} useModsyImgDefaults - Applies the baseline styles from modsy-ui-kit
 * @param {boolean} disableAutoSrcSet - Disables the auto generation of srcSet. Needed when we want to use full size images with overflow hidden.
 * @param {string} bucketName - Key for S3 bucket prefix. Defaults to modsy-wc.
 * @param {boolean} disableAutoEnhance - Disable auto enhancement of image.
 * @param {function} handleRef - [Optional] Called with DOM element (ref forwarding).
 *
 * Note:
 * The srcSet parameter is automatically generated by and covers all reasonable viewport widths.
 * For local dev, srcSet is intentionally disabled as there is only one available source image.
 */

function CompressedImage(_ref) {
  var bucketName = _ref.bucketName,
      crop = _ref.crop,
      fit = _ref.fit,
      src = _ref.src,
      sizes = _ref.sizes,
      height = _ref.height,
      width = _ref.width,
      masterImageWidth = _ref.masterImageWidth,
      className = _ref.className,
      _ref$disableAutoEnhan = _ref.disableAutoEnhance,
      disableAutoEnhance = _ref$disableAutoEnhan === void 0 ? true : _ref$disableAutoEnhan,
      disableAutoSrcSet = _ref.disableAutoSrcSet,
      _ref$onLoad = _ref.onLoad,
      onLoad = _ref$onLoad === void 0 ? function () {} : _ref$onLoad,
      useModsyImgDefaults = _ref.useModsyImgDefaults,
      handleRef = _ref.handleRef,
      otherHtmlAttributes = _objectWithoutProperties(_ref, _excluded); // If the incoming src is a data URI (or empty), then
  // there is nothing to compress or download.
  // We should just return a regular <img /> tag.


  var isDataUri = !src || src.startsWith('data:');

  if (isDataUri) {
    return (
      /*#__PURE__*/
      React.createElement("img", _extends({
        src: src,
        alt: otherHtmlAttributes.alt,
        className: className,
        height: height,
        width: width,
        ref: handleRef
      }, otherHtmlAttributes))
    );
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldFallback = _useState2[0],
      setShouldFallback = _useState2[1]; // Determine the imgix URL for this image without query search string.


  var imgixSrc = buildCompressedUrl(src, null, bucketName).split('?')[0]; // For now we are always using a set of default compression parameters.
  // But we allow overriding the default auto enhance config.

  var imgixParams = defaultImgixParams(disableAutoEnhance); // Optionally override the fit param

  if (fit) {
    imgixParams.fit = fit;
  } // Optionally override the crop param


  if (crop) {
    imgixParams.crop = crop;
  } // Allows using code to pass down additional attributes
  // that will get added to the final <img /> element.


  var htmlAttributes = _objectSpread2({}, otherHtmlAttributes);

  if (useModsyImgDefaults) {
    htmlAttributes.style = _objectSpread2(_objectSpread2({}, modsyUIKitDefaultImageStyles), htmlAttributes.style);
  } // Handle ref forwarding.


  if (handleRef) {
    htmlAttributes.ref = handleRef;
  } // Build out the srcset for this image.


  var autoGeneratSrcSet = !disableAutoSrcSet; // Do not put srcSet in htmlAttributes in case fallback is needed.

  if (!shouldFallback && autoGeneratSrcSet) {
    if (width && height) {
      htmlAttributes.srcSet = buildFixedSizeSrcSet(src, bucketName, imgixParams, width, height, masterImageWidth);
    } else {
      htmlAttributes.srcSet = buildResponsiveSrcSet(src, bucketName, imgixParams, masterImageWidth);
    }
  }

  var onError = otherHtmlAttributes.onError;
  htmlAttributes.onLoad = onLoad;

  htmlAttributes.onError = function () {
    if (onError) {
      onError();
    } // Safety in case the regular image fails to load in order to prevent infinite re-renders.


    if (!shouldFallback) {
      setShouldFallback(true);
    }
  }; // Suppress no "sizes" warning from react-imgix library when
  // there is no srcSet specified.
  //
  // If the srcset attribute is absent, or contains no values
  // with a width (w) descriptor, then the sizes attribute has no effect.
  // So for empty srcSet we can just set sizes to 100vw and it will
  // suppress the warning w/o any negative consequences.


  var useSizes = sizes;

  if (!useSizes && !htmlAttributes.srcSet) {
    useSizes = '100vw';
  }

  return shouldFallback ?
  /*#__PURE__*/
  React.createElement("img", _extends({
    src: src,
    alt: htmlAttributes.alt,
    className: className,
    height: height,
    width: width,
    ref: handleRef
  }, htmlAttributes)) :
  /*#__PURE__*/
  React.createElement(Imgix, {
    className: className // req'd for use with styled components
    ,
    disableLibraryParam: true // do not include imgix library info with requests
    ,
    disableSrcSet: true // disable this react-imgix srcset autogeneration logic
    ,
    height: height,
    htmlAttributes: htmlAttributes,
    imgixParams: imgixParams,
    src: imgixSrc,
    sizes: useSizes,
    width: width
  });
}
/**
 * For BW compatibility with modsy-ui-kit's Image component.
 * Applies the same set of default HTML attributes.
 *
 * Example usage drop in replacement:
 * <Image src={heroImg} /> ==> <CompressedImage src={heroImg} useModsyImgDefaults />
 */


var modsyUIKitDefaultImageStyles = {
  display: 'block',
  maxWidth: '100%',
  height: 'auto'
};
/**
 * These are the most common/important device breakpoints
 * as determined by defaults in Chrome DevTools responsive mode.
 */

var breakpoints = [320, // mobile small
375, // mobile medium
425, // mobile large
768, // tablet
1024, // laptop small or tablet large
1440, // laptop large
2560 // 4K
];
/**
 * These are the common/imporant device pixel ratios
 */

var dprs = [1, 2, 3, 4];
/**
 * Builds out the srcset attribute for fixed size image request.
 */

var buildFixedSizeSrcSet = function buildFixedSizeSrcSet(src, bucketName, imgixParams, fixedWidth, fixedHeight, masterImageWidth) {
  var srcset = '';

  var _iterator = _createForOfIteratorHelper(dprs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var dpr = _step.value; // Stop when we are 1 dpr beyond the master image width.
      // This is an optimization so we do not request an image size
      // more than 1 dpr beyond the master image width.

      if (masterImageWidth && fixedWidth * (dpr - 1) > masterImageWidth) {
        break;
      } // Build the source string for this breakpoint and it to srcset.


      var imgixUrl = buildCompressedUrl(src, _objectSpread2(_objectSpread2({}, imgixParams), {}, {
        w: fixedWidth,
        h: fixedHeight,
        dpr: dpr
      }), bucketName);
      srcset += "".concat(srcset ? ', ' : '').concat(imgixUrl, " ").concat(dpr, "x");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return srcset;
};
/**
 * Builds out the srcset attribute for a responsive image request.
 */


var buildResponsiveSrcSet = function buildResponsiveSrcSet(src, bucketName, imgixParams, masterImageWidth) {
  var srcset = '';

  var addSourceAtBreakpoint = function addSourceAtBreakpoint(breakpoint) {
    var imgixUrl = buildCompressedUrl(src, _objectSpread2(_objectSpread2({}, imgixParams), {}, {
      w: breakpoint
    }), bucketName);
    srcset += "".concat(srcset ? ', ' : '').concat(imgixUrl, " ").concat(breakpoint, "w");
  };

  var _iterator2 = _createForOfIteratorHelper(breakpoints),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var breakpoint = _step2.value; // Stop when we have passed the desired maximum width.

      if (masterImageWidth && breakpoint > masterImageWidth) {
        break;
      } // Build the source string for this breakpoint and it to srcset.


      addSourceAtBreakpoint(breakpoint);
    } // If the master image width has been provided, then add a final srcset at that width.

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (masterImageWidth) {
    addSourceAtBreakpoint(masterImageWidth);
  }

  return srcset;
};

export { CompressedImage, buildCompressedUrl, setRuntimeConfig };